/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import { ixmUserauthV1SessionServiceWhoami } from '@interxfi/api-client/generated/client-functions/ixm-userauth-v1-session-service-whoami';
import type { IxmUserauthV1SessionServiceWhoamiResponse } from '@interxfi/types';
import { type DefinedInitialDataOptions, queryOptions, useQuery } from '@tanstack/react-query';
import { schema } from 'normalizr';
import { ixmUserauthV1OrganizationMemberStateEntity } from '../entities/ixm-userauth-v1-organization-member-state';
import { ixmUserauthV1OrganizationStateEntity } from '../entities/ixm-userauth-v1-organization-state';
import { ixmUserauthV1RealmAccessStateEntity } from '../entities/ixm-userauth-v1-realm-access-state';
import { ixmUserauthV1RealmStateEntity } from '../entities/ixm-userauth-v1-realm-state';
import { ixmUserauthV1RoleStateEntity } from '../entities/ixm-userauth-v1-role-state';
import { ixmUserauthV1TenantStateEntity } from '../entities/ixm-userauth-v1-tenant-state';
import { ixmUserauthV1UserStateEntity } from '../entities/ixm-userauth-v1-user-state';

export const ixmUserauthV1SessionServiceWhoamiResponseEntity = new schema.Object<IxmUserauthV1SessionServiceWhoamiResponse>({
    user: ixmUserauthV1UserStateEntity,
    organizations: [new schema.Object({
            organizationMember: ixmUserauthV1OrganizationMemberStateEntity,
            organization: ixmUserauthV1OrganizationStateEntity
        })],
    realms: [new schema.Object({
            realm: ixmUserauthV1RealmStateEntity,
            tenant: ixmUserauthV1TenantStateEntity,
            access: ixmUserauthV1RealmAccessStateEntity,
            role: ixmUserauthV1RoleStateEntity
        })]
});
/**
 * @generated by NormalizedQueryPlugin (get /portal/userauth/v1/session/whoami) */

export function buildIxmUserauthV1SessionServiceWhoamiKey() { return ['ixmUserauthV1SessionServiceWhoami'] as const; }

export function buildIxmUserauthV1SessionServiceWhoamiQueryOptions(options?: Partial<DefinedInitialDataOptions<IxmUserauthV1SessionServiceWhoamiResponse | undefined>>) { return queryOptions({
    queryKey: buildIxmUserauthV1SessionServiceWhoamiKey(),
    queryFn: async () => ixmUserauthV1SessionServiceWhoami(''),
    enabled: true,
    meta: { normalizationSchema: ixmUserauthV1SessionServiceWhoamiResponseEntity },
    ...options
}); }

export function useIxmUserauthV1SessionServiceWhoami(options?: Partial<DefinedInitialDataOptions<IxmUserauthV1SessionServiceWhoamiResponse | undefined>>) {
    return useQuery(buildIxmUserauthV1SessionServiceWhoamiQueryOptions(options));
}
